export default {"src":"/_next/static/media/insuranceLogo3.ef25d3c6.svg","height":74,"width":105,"blurWidth":0,"blurHeight":0};